import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DynamicDialogRef } from "primeng/dynamicdialog";
import { IHaveDescription } from "../../have-description.interface";

@Component({
  selector: 'app-list-item-selector-modal',
  templateUrl: './list-item-selector-modal.component.html',
  styleUrls: ['./list-item-selector-modal.component.scss']
})

export class ListItemSelectorModalComponent implements OnInit {
  @Input() guidance: string;
  @Input() heading: string;
  @Input() cancelButtonText = 'Cancel';
  @Input() cancelButtonColour = 'danger';
  @Input() cancelButtonIcon: string = null;

  @Input() items: IHaveDescription[] = [];
  @Input() currentItem: IHaveDescription;

  @Output() itemSelected: EventEmitter<IHaveDescription> = new EventEmitter<IHaveDescription>();

  constructor(public modalRef: DynamicDialogRef) { }

  ngOnInit(): void {
  }

  selectItem(item: IHaveDescription) {
    this.itemSelected.emit(item);
    this.modalRef.close();
  }

  closeWithoutSelect() {
    this.itemSelected.emit(null);
    this.modalRef.close();
  }

  onItemSelected(item: IHaveDescription) {
    this.selectItem(item);
  }
}
